import { useEffect, useRef } from 'react';

const useVisibleInterval = (callback, delay, enabled, immediate = false) => {
  const saved = useRef(callback);
  saved.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;

    let timer = null;

    const run = () => {
      if (!document.hidden) saved.current();
    };

    const start = () => {
      if (timer) clearInterval(timer);
      timer = setInterval(run, delay);
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const onVisibility = () => {
      if (document.hidden) {
        stop();
        return;
      }
      run();
      start();
    };

    if (immediate && !document.hidden) run();
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [delay, enabled, immediate]);
};

export default useVisibleInterval;
